import * as React from 'react';
import styled from "styled-components";
import Paragraph from "../../atom/text/paragraph";
import {ConstBorderRound, ConstColor, ConstMargin} from "../../../../config/styles_const/styles_const";
import AvatarSmall from "../../atom/avatar/avatar_small";

interface IProps {
    avatarURL: string,
    avatarName: string,
}

const AvatarProfile: React.FC<IProps> = (props) => {

    const {avatarURL, avatarName} = props;

    return (
        <Wrapper>
            <Avatar src={avatarURL}/>
            <AvatarName bold={true}>{avatarName}</AvatarName>
        </Wrapper>
    );
};

export default (AvatarProfile);

const Wrapper = styled.div`
    padding: 20px 10px;
    margin: 20px ${ConstMargin.MenuItemRight};
    display: flex;
    align-items: center;   
    background: ${ConstColor.LightBlack};
    border-radius: ${ConstBorderRound.MenuProfile};
`;

const Avatar = styled(AvatarSmall)`
    margin-right: 10px;
`;

const AvatarName = styled(Paragraph)`
    color: ${ConstColor.White};  
`;


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/avatar_profile/avatar_profile.tsx